/**
 * tourSteps/timelineSteps.js
 * Comprehensive tour steps for the Timeline Gantt Chart & Dependency view.
 */

export const timelineSteps = [
    {
        title: 'Timeline & Gantt Schedule',
        description: 'Visualize task schedules, durations, and delivery roadmaps across an interactive continuous chronological Gantt grid.',
        selector: '[data-tour="timeline-board"]',
        placement: 'top',
    },
    {
        title: 'Pipeline Status Sidebar',
        description: 'Work items are organized by execution stage (In Progress, Under Review, Completed, On Hold). Click any section to collapse or expand its rows.',
        selector: '[data-tour="timeline-sidebar-pipeline"]',
        fallbackSelector: '[data-tour="timeline-board"]',
        placement: 'right',
    },
    {
        title: 'Interactive Schedule Bars',
        description: 'Each horizontal bar represents a task\'s start date through due date. Color coding reflects current status, and hover tooltips reveal assignee, project, and progress details.',
        selector: '[data-tour="timeline-gantt-bars"]',
        fallbackSelector: '[data-tour="timeline-board"]',
        placement: 'bottom',
    },
    {
        title: 'Task Dependencies & Risk Alerts',
        description: 'Visual arrows connect blocker tasks to downstream dependent tasks. Dashed red arrows highlight scheduling conflicts where dependent work starts before its blocker is completed.',
        selector: '[data-tour="timeline-dependencies"]',
        fallbackSelector: '[data-tour="timeline-gantt-bars"]',
        placement: 'top',
    },
    {
        title: 'Timescale Zoom Controls',
        description: 'Switch timeline granularity between Day, Week, Month, and Quarter views to view everything from daily work orders to high-level quarterly roadmaps.',
        selector: '[data-tour="timeline-view-modes"]',
        fallbackSelector: '[data-tour="timeline-board"]',
        placement: 'top',
    },
    {
        title: 'Date Navigation & "Today" Marker',
        description: 'Pan forward or backward across the schedule, or click "Today" to instantly snap the viewport to the current date indicator line.',
        selector: '[data-tour="timeline-navigation"]',
        fallbackSelector: '[data-tour="timeline-view-modes"]',
        placement: 'top',
    },
    {
        title: 'Schedule Intelligence & Insights',
        description: 'Right-hand analytics panel flags unscheduled tasks, overdue deadlines, and potential delivery bottlenecks before they impact project launch dates.',
        selector: '[data-tour="timeline-insights-panel"]',
        fallbackSelector: '[data-tour="timeline-board"]',
        placement: 'left',
    },
];
